import { Collection } from 'modules/core/lib/mobx-rest'

import PolicyTimeline from 'modules/timeoff/store/models/TimeoffPolicy/PolicyTimeline'

class PolicyTimelines extends Collection<PolicyTimeline> {
  get cacheKey(): string {
    return 'policyTimelines'
  }

  model() {
    return PolicyTimeline
  }

  get timeline() {
    return this.at(0)
  }
}

const singleton: PolicyTimelines = new PolicyTimelines()

export default singleton
